import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/Input';
/**
 * @class NCInput
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCInput
 * @label 文本框
 *
 */
class NCInput extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
         * @title className
         * @description 样式
         */
        className: PropTypes.string,
        /**
         * @title 必填标识
         * @description 必填标识
         */
        showStar: PropTypes.bool,
        /**
         * @title 自动化Id
         * @description 自动化Id
         */
        fieldid: PropTypes.string,

    }
    static getCompMeta = () => {
        return CompMeta;
    }
    render() {
        return (
            <Input {...this.props} />
        )
    }
}

export default NCInput;
